import React, { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ArrowLeft, Building2, Users, Heart, Camera, CheckCircle, MessageCircle, Crown, Star, Globe, Award, Sparkles, ChevronRight } from 'lucide-react';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { ScrollProgress } from '../components/ScrollProgress';
import { LanguageProvider } from '../context/LanguageContext';
export function CorporatePage() {
  return <LanguageProvider data-id="element-3840" data-mp="3tn6l6nvezefh">
      <div className="relative bg-black text-white overflow-x-hidden" data-id="element-3841" data-mp="bf7bwx30bhi6">
        <ScrollProgress data-id="element-3842" data-mp="bdcptfg01jci" />
        <Navbar data-id="element-3843" data-mp="7e3wgbovfnhh" />
        <main className="w-full" data-id="element-3844" data-mp="7dm2jlpollcq">
          <CorporateHero data-id="element-3845" data-mp="7capswe9d39h" />
          <WhyPartnerSection data-id="element-3846" data-mp="7g87rep3nors" />
          <TheExperienceSection data-id="element-3847" data-mp="1mu2xl302mj88" />
          <SponsorshipTiersSection data-id="element-3848" data-mp="1mt1b82dluab7" />
          <AudienceSection data-id="element-3849" data-mp="1it0yqna2g96s" />
          <BenefitsSection data-id="element-3850" data-mp="1itsj11y7qkhr" />
          <CorporateCTA data-id="element-3851" data-mp="1ishfn38ojer6" />
        </main>
        <Footer data-id="element-3852" data-mp="3k1sakfydv0xz" />
      </div>
    </LanguageProvider>;
}
function CorporateHero() {
  return <section className="relative w-full min-h-screen bg-black flex items-center justify-center overflow-hidden" data-id="element-3853" data-mp="3k44mochgmh34">
      <div className="absolute inset-0" data-id="element-3854" data-mp="3t2q4u6j0ru3d">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/pxKq2k9j3qcBE1TheAWARz/Experience_image.png" alt="Life in the Sikh Kingdoms" className="w-full h-full object-cover opacity-30" data-id="element-3855" data-mp="3t3rqf4xnvyzc" />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-black" data-id="element-3856" data-mp="3197njf5d7q23"></div>
      </div>

      <div className="relative z-10 text-center px-4 max-w-5xl mx-auto" data-id="element-3857" data-mp="3abyyldubwjt7">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.1
      }} data-id="element-3858" data-mp="3aansh7deuzyx">
          <Link to="/" className="inline-flex items-center gap-2 text-amber-400/70 hover:text-amber-400 text-sm tracking-wider uppercase font-light mb-12 transition-colors" data-id="element-3859" data-mp="2ml3buv4qcest">
            <ArrowLeft className="w-4 h-4" data-id="element-3860" data-mp="3kxpdajk9066c" />
            Back to Life in the Sikh Kingdoms
          </Link>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1,
        delay: 0.2
      }} data-id="element-3861" data-mp="2m2c1y21nuwf">
          <p className="text-amber-400/60 tracking-[0.3em] text-xs uppercase mb-6 font-light" data-id="element-3862" data-mp="320xlflqn4iqo">
            Presented by Akal Steel
          </p>
          <p className="text-amber-400 tracking-[0.3em] text-xs md:text-sm uppercase mb-8 font-light" data-id="element-3863" data-mp="3b019730r5mbi">
            Brand Partnership &amp; Sponsorship
          </p>
          <h1 className="font-serif text-5xl md:text-7xl lg:text-8xl text-white mb-8 tracking-tight leading-none" data-id="element-3864" data-mp="v728v8w7go24">
            CORPORATE
            <br data-id="element-3865" data-mp="yr2ohx9o8ovm" />
            <span className="text-amber-400" data-id="element-3866" data-mp="yqkul7ahemqv">PARTNERSHIP</span>
          </h1>
          <div className="w-24 h-px bg-amber-400/30 mx-auto mb-8" data-id="element-3867" data-mp="12s63khjwagvs"></div>
          <p className="text-xl md:text-2xl text-white/70 font-light max-w-3xl mx-auto leading-relaxed" data-id="element-3868" data-mp="12qbfwvh8oao0">
            Transform Your Next Event Into an Unforgettable Cultural Experience
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.6
      }} className="mt-12 flex flex-col sm:flex-row items-center justify-center gap-8 text-white/60" data-id="element-3869" data-mp="1hhbyvufm3mye">
          <div className="text-center" data-id="element-3870" data-mp="1cor6mxccthwz">
            <p className="text-sm tracking-[0.2em] uppercase mb-1 text-amber-400" data-id="element-3871" data-mp="20fob5p1tlcy7">
              Up to
            </p>
            <p className="font-serif text-3xl text-white" data-id="element-3872" data-mp="257y8hq59lfai">120</p>
            <p className="text-xs font-light" data-id="element-3873" data-mp="gl3o938tka7o">Guests Per Evening</p>
          </div>
          <div className="hidden sm:block w-px h-12 bg-white/20" data-id="element-3874" data-mp="giqwjyd9elhf"></div>
          <div className="text-center" data-id="element-3875" data-mp="chx9f77n5apl">
            <p className="text-sm tracking-[0.2em] uppercase mb-1 text-amber-400" data-id="element-3876" data-mp="7kdwcamoj3z8">
              Venue
            </p>
            <p className="font-serif text-xl text-white" data-id="element-3877" data-mp="2lu6hz4yt81l">Illuminarium</p>
            <p className="text-xs font-light" data-id="element-3878" data-mp="2nncrdbo1q92">Toronto</p>
          </div>
          <div className="hidden sm:block w-px h-12 bg-white/20" data-id="element-3879" data-mp="1089od21b07po"></div>
          <div className="text-center" data-id="element-3880" data-mp="vb16l2k2i5oy">
            <p className="text-sm tracking-[0.2em] uppercase mb-1 text-amber-400" data-id="element-3881" data-mp="vc2qzxmz44jc">
              Available
            </p>
            <p className="font-serif text-xl text-white" data-id="element-3882" data-mp="lkg9jjk1l985">Summer</p>
            <p className="text-xs font-light" data-id="element-3883" data-mp="ljwtk8dycuwr">2026</p>
          </div>
        </motion.div>
      </div>

      <motion.div className="absolute bottom-8 left-1/2 transform -translate-x-1/2" animate={{
      y: [0, 10, 0]
    }} transition={{
      duration: 2,
      repeat: Infinity
    }} data-id="element-3884" data-mp="1j1ndgqic5jxd">
        <div className="w-px h-16 bg-gradient-to-b from-transparent via-white/50 to-transparent" data-id="element-3885" data-mp="1qijv5eva7tw6"></div>
      </motion.div>
    </section>;
}
function WhyPartnerSection() {
  const sectionRef = useRef<HTMLElement>(null);
  const {
    scrollYProgress
  } = useScroll({
    target: sectionRef,
    offset: ['start end', 'end start']
  });
  const opacity = useTransform(scrollYProgress, [0, 0.2, 0.8, 1], [0, 1, 1, 0]);
  return <motion.section ref={sectionRef} style={{
    opacity
  }} className="py-20 md:py-28 bg-black relative overflow-hidden" data-id="element-3886" data-mp="29gw6n79o1fux">
      <div className="absolute inset-0 bg-gradient-to-b from-amber-950/10 to-black z-0" data-id="element-3887" data-mp="2j7r4za06s5wq"></div>
      <div className="container mx-auto px-4 relative z-10" data-id="element-3888" data-mp="2j9lels60cbli">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-16" data-id="element-3889" data-mp="2o855m6zgkdkq">
          <p className="text-amber-400/60 tracking-[0.3em] text-xs uppercase mb-6" data-id="element-3890" data-mp="11vquuplkfj2b">
            The Case for Partnership
          </p>
          <h2 className="font-serif text-5xl md:text-6xl text-white mb-8" data-id="element-3891" data-mp="x47pqvcllqyz">
            WHY <span className="text-amber-400" data-id="element-3892" data-mp="1btnd01cx7e9x">PARTNER</span>
          </h2>
          <div className="w-24 h-px bg-amber-400/30 mx-auto mb-8" data-id="element-3893" data-mp="16v2fi9p1z8p6"></div>
          <p className="text-xl text-white/70 max-w-3xl mx-auto font-light leading-relaxed" data-id="element-3894" data-mp="16uu28gp0q1dg">
            Life in the Sikh Kingdoms offers a rare opportunity to align your
            brand with heritage, excellence, and multicultural innovation at one
            of Toronto's most prestigious cultural events.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-3895" data-mp="3il4onopzv2j0">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0
        }} className="border-2 border-amber-400/30 p-8 bg-black/40" data-id="element-3896" data-mp="38go8eu8lrjeo">
            <Building2 className="w-8 h-8 text-amber-400 mb-4" data-id="element-3897" data-mp="2ornmlex0vprj" />
            <h3 className="font-serif text-2xl text-amber-400 mb-3" data-id="element-3898" data-mp="2trs1x1m72eg6">
              Brand Alignment
            </h3>
            <p className="text-white/70 font-light leading-relaxed" data-id="element-3899" data-mp="2fsk0s36h0w9c">
              Associate your brand with heritage, excellence, and multicultural
              innovation. Position yourself as a champion of cultural
              preservation and community investment in one of Canada's most
              dynamic cities.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.1
        }} className="border-2 border-amber-400/30 p-8 bg-black/40" data-id="element-3900" data-mp="ixe8fpremy47">
            <Crown className="w-8 h-8 text-amber-400 mb-4" data-id="element-3901" data-mp="18tyanvby5awa" />
            <h3 className="font-serif text-2xl text-amber-400 mb-3" data-id="element-3902" data-mp="18rbs70nipaza">
              Exclusive Access
            </h3>
            <p className="text-white/70 font-light leading-relaxed" data-id="element-3903" data-mp="yv8qtx0hpgde">
              Host a private venue for up to 120 guests with the full immersive
              experience — 360° projections, royal Punjabi cuisine, and
              interactive technology. An evening your clients and partners will
              never forget.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="border-2 border-amber-400/30 p-8 bg-black/40" data-id="element-3904" data-mp="2p8puvkyxvbui">
            <Heart className="w-8 h-8 text-amber-400 mb-4" data-id="element-3905" data-mp="3o6yt75jwsl1t" />
            <h3 className="font-serif text-2xl text-amber-400 mb-3" data-id="element-3906" data-mp="3o8ryohiscz88">
              Community Impact
            </h3>
            <p className="text-white/70 font-light leading-relaxed" data-id="element-3907" data-mp="3t7moi3f67o1u">
              Align your CSR mandate with cultural preservation and youth
              education. A portion of all proceeds goes directly to the Sikh Art
              and Culture Gallery at the Royal Ontario Museum — a tangible,
              meaningful contribution.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.3
        }} className="border-2 border-amber-400/30 p-8 bg-black/40" data-id="element-3908" data-mp="1heehajnmhi05">
            <Camera className="w-8 h-8 text-amber-400 mb-4" data-id="element-3909" data-mp="1ag7pui0m9n8v" />
            <h3 className="font-serif text-2xl text-amber-400 mb-3" data-id="element-3910" data-mp="1ahsmqeaeli9w">
              Media Exposure
            </h3>
            <p className="text-white/70 font-light leading-relaxed" data-id="element-3911" data-mp="1fgvpfs2wvcep">
              Dignitary presence, press coverage, and premium photo
              opportunities. Events with cultural significance attract ethnic
              media, community papers, and broader press — amplifying your brand
              story organically.
            </p>
          </motion.div>
        </div>
      </div>
    </motion.section>;
}
function TheExperienceSection() {
  const sectionRef = useRef<HTMLElement>(null);
  const {
    scrollYProgress
  } = useScroll({
    target: sectionRef,
    offset: ['start end', 'end start']
  });
  const opacity = useTransform(scrollYProgress, [0, 0.2, 0.8, 1], [0, 1, 1, 0]);
  return <motion.section ref={sectionRef} style={{
    opacity
  }} className="py-20 md:py-28 bg-black relative overflow-hidden" data-id="element-3912" data-mp="fcw11ob4xlek">
      <div className="container mx-auto px-4" data-id="element-3913" data-mp="5huaco17ob9v">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-16" data-id="element-3914" data-mp="hy8auc2qtwy">
          <p className="text-amber-400/60 tracking-[0.3em] text-xs uppercase mb-6" data-id="element-3915" data-mp="1qt2v67claj22">
            What Your Guests Will Experience
          </p>
          <h2 className="font-serif text-5xl md:text-6xl text-white mb-8" data-id="element-3916" data-mp="24zxqdauj4hse">
            THE <span className="text-amber-400" data-id="element-3917" data-mp="24xtcq16tw4ex">EXPERIENCE</span>
          </h2>
          <div className="w-24 h-px bg-amber-400/30 mx-auto" data-id="element-3918" data-mp="29rfolr56449o"></div>
        </motion.div>

        <div className="max-w-6xl mx-auto" data-id="element-3919" data-mp="1w0an0ji8p1wp">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-3920" data-mp="1vxenwruno76o">
            <motion.div initial={{
            opacity: 0,
            x: -30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8
          }} data-id="element-3921" data-mp="20yki6u3ys2ib">
              <div className="aspect-video relative overflow-hidden" data-id="element-3922" data-mp="2jniriz7ug6xo">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/rru8mxg1f864Swgj1TtDBp/Gemini_Generated_Image_xf598lxf598lxf59.png" alt="Immersive Experience" className="w-full h-full object-cover" data-id="element-3923" data-mp="13a0yrfx78fx4" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" data-id="element-3924" data-mp="vr1gxepdywfv"></div>
              </div>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            x: 30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8
          }} className="space-y-6" data-id="element-3925" data-mp="19pj2b5rtjwum">
              <p className="text-white/80 text-lg leading-relaxed font-light" data-id="element-3926" data-mp="qtj4vfg2o13n">
                Step into the court of Maharaja Ranjit Singh, where history
                unfolds not behind glass, but all around you. Through walls that
                transform, floors that transport, and flavors that resurrect a
                golden age.
              </p>

              <div className="border-l-2 border-amber-400/30 pl-6 space-y-4" data-id="element-3927" data-mp="6zt7d8239zwb">
                <div className="flex items-start" data-id="element-3928" data-mp="bye06mf0hhaq">
                  <span className="text-amber-400 mr-3 mt-1" data-id="element-3929" data-mp="byw3g303cvs5">—</span>
                  <span className="text-white/70 font-light" data-id="element-3930" data-mp="gx7dadqdz6ad">
                    5–7 courses synchronized with immersive projections
                  </span>
                </div>
                <div className="flex items-start" data-id="element-3931" data-mp="pq17dhahsa8a">
                  <span className="text-amber-400 mr-3 mt-1" data-id="element-3932" data-mp="pp99fztfa0eu">—</span>
                  <span className="text-white/70 font-light" data-id="element-3933" data-mp="uo2ohwocxzh4">
                    360° visual storytelling across walls, floor, and tables
                  </span>
                </div>
                <div className="flex items-start" data-id="element-3934" data-mp="14nl82c0cvj8n">
                  <span className="text-amber-400 mr-3 mt-1" data-id="element-3935" data-mp="14ma4ac6wubhj">—</span>
                  <span className="text-white/70 font-light" data-id="element-3936" data-mp="31gdb6x7faze5">
                    Royal Punjabi cuisine from world-renowned chefs
                  </span>
                </div>
                <div className="flex items-start" data-id="element-3937" data-mp="1njtsx0k3bh9n">
                  <span className="text-amber-400 mr-3 mt-1" data-id="element-3938" data-mp="1nklcte4brqk3">—</span>
                  <span className="text-white/70 font-light" data-id="element-3939" data-mp="1iriszxpcnvh3">
                    90 minutes of complete immersion
                  </span>
                </div>
                <div className="flex items-start" data-id="element-3940" data-mp="19rvsde4g2tp3">
                  <span className="text-amber-400 mr-3 mt-1" data-id="element-3941" data-mp="19t6wxg5ps5h9">—</span>
                  <span className="text-white/70 font-light" data-id="element-3942" data-mp="26io5c2w305mn">
                    Interactive technology — voice, motion, and scent
                  </span>
                </div>
              </div>

              <div className="border border-amber-400/30 p-6 bg-black/40" data-id="element-3943" data-mp="1xgyf30dxrcqg">
                <div className="grid grid-cols-3 gap-4 text-center" data-id="element-3944" data-mp="1sidev0yoot20">
                  <div data-id="element-3945" data-mp="1si53xem4fxtg">
                    <p className="text-amber-400 text-xs tracking-wider uppercase mb-1" data-id="element-3946" data-mp="m2b5wl931eb2">
                      Venue
                    </p>
                    <p className="text-white font-light text-sm" data-id="element-3947" data-mp="h26ngpom69i7">
                      Illuminarium Toronto
                    </p>
                  </div>
                  <div data-id="element-3948" data-mp="njhxnutukanp">
                    <p className="text-amber-400 text-xs tracking-wider uppercase mb-1" data-id="element-3949" data-mp="nk023eqnxv6p">
                      Date
                    </p>
                    <p className="text-white font-light text-sm" data-id="element-3950" data-mp="9j73oix8qfyb">Summer 2026</p>
                  </div>
                  <div data-id="element-3951" data-mp="egywrg9mg843">
                    <p className="text-amber-400 text-xs tracking-wider uppercase mb-1" data-id="element-3952" data-mp="ekmsmm2jh6lz">
                      Capacity
                    </p>
                    <p className="text-white font-light text-sm" data-id="element-3953" data-mp="4lnrrpo0mf9j">
                      Up to 120 Guests
                    </p>
                  </div>
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </motion.section>;
}
function SponsorshipTiersSection() {
  const sectionRef = useRef<HTMLElement>(null);
  const {
    scrollYProgress
  } = useScroll({
    target: sectionRef,
    offset: ['start end', 'end start']
  });
  const opacity = useTransform(scrollYProgress, [0, 0.2, 0.8, 1], [0, 1, 1, 0]);
  return <motion.section ref={sectionRef} style={{
    opacity
  }} className="py-20 md:py-28 bg-black relative overflow-hidden" data-id="element-3954" data-mp="2tevunaloo5qx">
      <div className="absolute inset-0 bg-gradient-to-b from-amber-950/10 to-black z-0" data-id="element-3955" data-mp="38dhfr0egddlo"></div>
      <div className="container mx-auto px-4 relative z-10" data-id="element-3956" data-mp="33b8oc8h8ajlo">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-16" data-id="element-3957" data-mp="3hc2v6momoci8">
          <p className="text-amber-400/60 tracking-[0.3em] text-xs uppercase mb-6" data-id="element-3958" data-mp="3m430yvrdpzmq">
            Investment Levels
          </p>
          <h2 className="font-serif text-5xl md:text-6xl text-white mb-8" data-id="element-3959" data-mp="3w1h5bx012xyo">
            SPONSORSHIP <span className="text-amber-400" data-id="element-3960" data-mp="3vzo08m52clss">TIERS</span>
          </h2>
          <div className="w-24 h-px bg-amber-400/30 mx-auto mb-8" data-id="element-3961" data-mp="16aj7glt7z6sd"></div>
          <p className="text-white/70 font-light max-w-2xl mx-auto" data-id="element-3962" data-mp="1b92s8iw2ucj5">
            Each tier is designed to deliver meaningful brand value while
            supporting cultural preservation and community impact.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto" data-id="element-3963" data-mp="1k8pray1c3691">
          {/* Presenting Partner */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0
        }} className="relative" data-id="element-3964" data-mp="sjntww7s01ig">
            <div className="absolute top-0 left-0 right-0 flex justify-center z-30 transform -translate-y-1/2" data-id="element-3965" data-mp="8vf06hql3ngu">
              <div className="bg-amber-400 text-black font-bold py-2 px-6 flex items-center gap-2" data-id="element-3966" data-mp="1cnu2535r397">
                <Star className="w-4 h-4" fill="currentColor" data-id="element-3967" data-mp="3shxgjmry0ze2" />
                <span className="text-xs uppercase tracking-wider" data-id="element-3968" data-mp="3sgmafgb0zfjs">
                  Flagship
                </span>
              </div>
            </div>
            <div className="border-2 border-amber-400 bg-black/80 p-8 pt-12 h-full flex flex-col" data-id="element-3969" data-mp="3jgpin5tca0ki">
              <div className="text-center mb-6" data-id="element-3970" data-mp="3ejpjleuwpy2w">
                <Crown className="w-10 h-10 text-amber-400 mx-auto mb-3" data-id="element-3971" data-mp="3ekihdqbw1d8w" />
                <h3 className="font-serif text-2xl text-white mb-1" data-id="element-3972" data-mp="39qmrlb5s2wot">
                  Presenting Partner
                </h3>
                <div className="w-12 h-px bg-amber-400/30 mx-auto mt-3" data-id="element-3973" data-mp="30r9feaq9ru0e"></div>
              </div>
              <ul className="space-y-3 flex-grow" data-id="element-3974" data-mp="2vs6khj407465">
                <li className="flex items-start text-white/70 text-sm font-light" data-id="element-3975" data-mp="2vqv5so90sc09">
                  <span className="w-1.5 h-1.5 rounded-full bg-amber-400 mr-3 mt-1.5 flex-shrink-0" data-id="element-3976" data-mp="2qstpgb2zaqsh"></span>
                  Full venue branding throughout the evening
                </li>
                <li className="flex items-start text-white/70 text-sm font-light" data-id="element-3977" data-mp="2kl47mpn6g6f1">
                  <span className="w-1.5 h-1.5 rounded-full bg-amber-400 mr-3 mt-1.5 flex-shrink-0" data-id="element-3978" data-mp="2fmap2it19p80"></span>
                  2 Patron Circle tables (20 guests)
                </li>
                <li className="flex items-start text-white/70 text-sm font-light" data-id="element-3979" data-mp="2apu1bppqxcvg">
                  <span className="w-1.5 h-1.5 rounded-full bg-amber-400 mr-3 mt-1.5 flex-shrink-0" data-id="element-3980" data-mp="26n793np5xpxq"></span>
                  Logo on all event materials &amp; press releases
                </li>
                <li className="flex items-start text-white/70 text-sm font-light" data-id="element-3981" data-mp="1wwck4bkj8c8l">
                  <span className="w-1.5 h-1.5 rounded-full bg-amber-400 mr-3 mt-1.5 flex-shrink-0" data-id="element-3982" data-mp="1ryb3ryehqr0t"></span>
                  Press conference inclusion &amp; media opportunity
                </li>
                <li className="flex items-start text-white/70 text-sm font-light" data-id="element-3983" data-mp="1ixl60p5o6qkg">
                  <span className="w-1.5 h-1.5 rounded-full bg-amber-400 mr-3 mt-1.5 flex-shrink-0" data-id="element-3984" data-mp="3uilqgtmtslwg"></span>
                  VIP reception hosting rights
                </li>
                <li className="flex items-start text-white/70 text-sm font-light" data-id="element-3985" data-mp="7f78sqf6jla4">
                  <span className="w-1.5 h-1.5 rounded-full bg-amber-400 mr-3 mt-1.5 flex-shrink-0" data-id="element-3986" data-mp="ce0mojydpeat"></span>
                  Dedicated social media feature campaign
                </li>
                <li className="flex items-start text-white/70 text-sm font-light" data-id="element-3987" data-mp="3atl51ff5qu9u">
                  <span className="w-1.5 h-1.5 rounded-full bg-amber-400 mr-3 mt-1.5 flex-shrink-0" data-id="element-3988" data-mp="3fv0ox45lmuqn"></span>
                  Tax-deductible charitable donation receipt
                </li>
              </ul>
              <motion.a href="https://wa.me/14169998778?text=I%20am%20interested%20in%20the%20Presenting%20Partner%20sponsorship%20for%20Life%20in%20the%20Sikh%20Kingdoms" target="_blank" rel="noopener noreferrer" className="mt-8 w-full bg-amber-400 hover:bg-amber-500 text-black py-3 text-center text-sm tracking-wider uppercase font-medium transition-colors duration-300 block" whileHover={{
              scale: 1.02
            }} whileTap={{
              scale: 0.98
            }} data-id="element-3989" data-mp="3plveoii20cgu">
                Inquire Now
              </motion.a>
            </div>
          </motion.div>

          {/* Cultural Partner */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.1
        }} data-id="element-3990" data-mp="223m4o8mwk049">
            <div className="border-2 border-amber-400/30 bg-black/80 p-8 h-full flex flex-col" data-id="element-3991" data-mp="3rjveq8d3th4d">
              <div className="text-center mb-6" data-id="element-3992" data-mp="3mlbo3unkfh5o">
                <Award className="w-10 h-10 text-amber-400 mx-auto mb-3" data-id="element-3993" data-mp="18a51twm3wjbq" />
                <h3 className="font-serif text-2xl text-white mb-1" data-id="element-3994" data-mp="1dassgh6fay5f">
                  Cultural Partner
                </h3>
                <div className="w-12 h-px bg-amber-400/30 mx-auto mt-3" data-id="element-3995" data-mp="zbjnyerkxsha"></div>
              </div>
              <ul className="space-y-3 flex-grow" data-id="element-3996" data-mp="14amhb1y76a9f">
                <li className="flex items-start text-white/70 text-sm font-light" data-id="element-3997" data-mp="14bfrkcwd7hwb">
                  <span className="w-1.5 h-1.5 rounded-full bg-amber-400 mr-3 mt-1.5 flex-shrink-0" data-id="element-3998" data-mp="1s1a4eugop6gk"></span>
                  1 Patron Circle table (10 guests)
                </li>
                <li className="flex items-start text-white/70 text-sm font-light" data-id="element-3999" data-mp="1i8umfx5e0hvo">
                  <span className="w-1.5 h-1.5 rounded-full bg-amber-400 mr-3 mt-1.5 flex-shrink-0" data-id="element-4000" data-mp="1n7fe386kpt8i"></span>
                  Logo on select event materials
                </li>
                <li className="flex items-start text-white/70 text-sm font-light" data-id="element-4001" data-mp="2fp9vxwltl0w7">
                  <span className="w-1.5 h-1.5 rounded-full bg-amber-400 mr-3 mt-1.5 flex-shrink-0" data-id="element-4002" data-mp="r2xb2f7c2q5i"></span>
                  Social media mention &amp; feature
                </li>
                <li className="flex items-start text-white/70 text-sm font-light" data-id="element-4003" data-mp="m66zo56h4iqf">
                  <span className="w-1.5 h-1.5 rounded-full bg-amber-400 mr-3 mt-1.5 flex-shrink-0" data-id="element-4004" data-mp="i2iq5gya7d2j"></span>
                  Behind-the-scenes preview access
                </li>
                <li className="flex items-start text-white/70 text-sm font-light" data-id="element-4005" data-mp="19s545q5o05i4">
                  <span className="w-1.5 h-1.5 rounded-full bg-amber-400 mr-3 mt-1.5 flex-shrink-0" data-id="element-4006" data-mp="15rl8ys4njbym"></span>
                  Branded photo moment at the event
                </li>
                <li className="flex items-start text-white/70 text-sm font-light" data-id="element-4007" data-mp="w2a2zed2aney">
                  <span className="w-1.5 h-1.5 rounded-full bg-amber-400 mr-3 mt-1.5 flex-shrink-0" data-id="element-4008" data-mp="1thfjh31i0ofp"></span>
                  Tax-deductible charitable donation receipt
                </li>
              </ul>
              <motion.a href="https://wa.me/14169998778?text=I%20am%20interested%20in%20the%20Cultural%20Partner%20sponsorship%20for%20Life%20in%20the%20Sikh%20Kingdoms" target="_blank" rel="noopener noreferrer" className="mt-8 w-full border border-amber-400/50 hover:bg-amber-400 hover:text-black text-white py-3 text-center text-sm tracking-wider uppercase font-light transition-all duration-300 block" whileHover={{
              scale: 1.02
            }} whileTap={{
              scale: 0.98
            }} data-id="element-4009" data-mp="1w23pwp3dbpcm">
                Inquire Now
              </motion.a>
            </div>
          </motion.div>

          {/* Community Partner */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} data-id="element-4010" data-mp="2trow350ihmvd">
            <div className="border-2 border-amber-400/30 bg-black/80 p-8 h-full flex flex-col" data-id="element-4011" data-mp="ynqv5pw1rqtl">
              <div className="text-center mb-6" data-id="element-4012" data-mp="1cema9jx5345m">
                <Globe className="w-10 h-10 text-amber-400 mx-auto mb-3" data-id="element-4013" data-mp="17n47qrfgwvij" />
                <h3 className="font-serif text-2xl text-white mb-1" data-id="element-4014" data-mp="17lt18jun19nq">
                  Community Partner
                </h3>
                <div className="w-12 h-px bg-amber-400/30 mx-auto mt-3" data-id="element-4015" data-mp="1hcxijq7sd6lq"></div>
              </div>
              <ul className="space-y-3 flex-grow" data-id="element-4016" data-mp="1vcq4l88daynd">
                <li className="flex items-start text-white/70 text-sm font-light" data-id="element-4017" data-mp="1vbf5hlpvaf2l">
                  <span className="w-1.5 h-1.5 rounded-full bg-amber-400 mr-3 mt-1.5 flex-shrink-0" data-id="element-4018" data-mp="1qeon2rqlb7e0"></span>
                  5 Founder Circle tickets
                </li>
                <li className="flex items-start text-white/70 text-sm font-light" data-id="element-4019" data-mp="3s58fdz6x3vk0">
                  <span className="w-1.5 h-1.5 rounded-full bg-amber-400 mr-3 mt-1.5 flex-shrink-0" data-id="element-4020" data-mp="3s7crh4ez00vd"></span>
                  Logo on community-facing materials
                </li>
                <li className="flex items-start text-white/70 text-sm font-light" data-id="element-4021" data-mp="2cl9biwuhl87x">
                  <span className="w-1.5 h-1.5 rounded-full bg-amber-400 mr-3 mt-1.5 flex-shrink-0" data-id="element-4022" data-mp="1yu4em2ii6u1a"></span>
                  Newsletter mention &amp; community recognition
                </li>
                <li className="flex items-start text-white/70 text-sm font-light" data-id="element-4023" data-mp="1ovopu66y7wuy">
                  <span className="w-1.5 h-1.5 rounded-full bg-amber-400 mr-3 mt-1.5 flex-shrink-0" data-id="element-4024" data-mp="1twkpu8o6iyv3"></span>
                  Youth program sponsorship opportunity
                </li>
                <li className="flex items-start text-white/70 text-sm font-light" data-id="element-4025" data-mp="1jwtvq83j6lvj">
                  <span className="w-1.5 h-1.5 rounded-full bg-amber-400 mr-3 mt-1.5 flex-shrink-0" data-id="element-4026" data-mp="3aa2i7quwwnv4"></span>
                  Tax-deductible charitable donation receipt
                </li>
              </ul>
              <motion.a href="https://wa.me/14169998778?text=I%20am%20interested%20in%20the%20Community%20Partner%20sponsorship%20for%20Life%20in%20the%20Sikh%20Kingdoms" target="_blank" rel="noopener noreferrer" className="mt-8 w-full border border-amber-400/50 hover:bg-amber-400 hover:text-black text-white py-3 text-center text-sm tracking-wider uppercase font-light transition-all duration-300 block" whileHover={{
              scale: 1.02
            }} whileTap={{
              scale: 0.98
            }} data-id="element-4027" data-mp="221rj1k73enss">
                Inquire Now
              </motion.a>
            </div>
          </motion.div>
        </div>
      </div>
    </motion.section>;
}
function AudienceSection() {
  const sectionRef = useRef<HTMLElement>(null);
  const {
    scrollYProgress
  } = useScroll({
    target: sectionRef,
    offset: ['start end', 'end start']
  });
  const opacity = useTransform(scrollYProgress, [0, 0.2, 0.8, 1], [0, 1, 1, 0]);
  return <motion.section ref={sectionRef} style={{
    opacity
  }} className="py-20 md:py-28 bg-black relative overflow-hidden" data-id="element-4028" data-mp="37780wyf0wyzh">
      <div className="container mx-auto px-4" data-id="element-4029" data-mp="3g2nnqvhd2dvk">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-16" data-id="element-4030" data-mp="3g3yrivat3lmo">
          <p className="text-amber-400/60 tracking-[0.3em] text-xs uppercase mb-6" data-id="element-4031" data-mp="2xa3agme5ahcv">
            Who You'll Reach
          </p>
          <h2 className="font-serif text-5xl md:text-6xl text-white mb-8" data-id="element-4032" data-mp="32bix2ivz0vxd">
            AUDIENCE &amp; <span className="text-amber-400" data-id="element-4033" data-mp="ckdwscp6h1lr">DEMOGRAPHICS</span>
          </h2>
          <div className="w-24 h-px bg-amber-400/30 mx-auto" data-id="element-4034" data-mp="hixlgkv5orht"></div>
        </motion.div>

        <div className="max-w-5xl mx-auto" data-id="element-4035" data-mp="2izni14uhc0hi">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mb-16" data-id="element-4036" data-mp="2j0p404d1a7e0">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: 0
          }} className="border border-amber-400/30 p-6 text-center bg-black/40" data-id="element-4037" data-mp="2n07f68f1z43n">
              <p className="font-serif text-4xl text-amber-400 mb-2" data-id="element-4038" data-mp="1qc03o7jsy63b">120</p>
              <p className="text-white/60 text-xs font-light tracking-wider uppercase" data-id="element-4039" data-mp="1va1ksmxo3vc5">
                Guests Per Evening
              </p>
            </motion.div>
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: 0.1
          }} className="border border-amber-400/30 p-6 text-center bg-black/40" data-id="element-4040" data-mp="3kq0x2cwl20w0">
              <p className="font-serif text-4xl text-amber-400 mb-2" data-id="element-4041" data-mp="7mx8lg5lvwv2">HNW</p>
              <p className="text-white/60 text-xs font-light tracking-wider uppercase" data-id="element-4042" data-mp="mcl769mekhf3">
                High-Net-Worth Attendees
              </p>
            </motion.div>
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: 0.2
          }} className="border border-amber-400/30 p-6 text-center bg-black/40" data-id="element-4043" data-mp="vdsvpzz4a3vz">
              <p className="font-serif text-4xl text-amber-400 mb-2" data-id="element-4044" data-mp="w5kluhelnl5z">50+</p>
              <p className="text-white/60 text-xs font-light tracking-wider uppercase" data-id="element-4045" data-mp="112jeswmj1m2l">
                Diaspora Leaders &amp; Professionals
              </p>
            </motion.div>
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: 0.3
          }} className="border border-amber-400/30 p-6 text-center bg-black/40" data-id="element-4046" data-mp="1b18klr15fg2h">
              <p className="font-serif text-4xl text-amber-400 mb-2" data-id="element-4047" data-mp="1yr2xg8lgx4mq">Press</p>
              <p className="text-white/60 text-xs font-light tracking-wider uppercase" data-id="element-4048" data-mp="22r4zwjz12232">
                Media &amp; Cultural Influencers
              </p>
            </motion.div>
          </div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="border-2 border-amber-400/40 p-8 md:p-12 bg-gradient-to-br from-amber-950/20 to-black/60 text-center" data-id="element-4049" data-mp="3j8c21mqqnq1y">
            <Heart className="w-8 h-8 text-amber-400 mx-auto mb-4" data-id="element-4050" data-mp="5vacbwt8lkvs" />
            <p className="text-2xl text-amber-400 font-light italic mb-4" data-id="element-4051" data-mp="11647a88j6t4">
              "A portion of all proceeds goes directly to the Sikh Art and
              Culture Gallery at the Royal Ontario Museum, preserving Sikh
              heritage for future generations."
            </p>
            <p className="text-white/50 text-sm font-light tracking-wider uppercase" data-id="element-4052" data-mp="or0fvogtipbs">
              Your sponsorship is a tax-deductible charitable contribution
            </p>
          </motion.div>
        </div>
      </div>
    </motion.section>;
}
function BenefitsSection() {
  const sectionRef = useRef<HTMLElement>(null);
  const {
    scrollYProgress
  } = useScroll({
    target: sectionRef,
    offset: ['start end', 'end start']
  });
  const opacity = useTransform(scrollYProgress, [0, 0.2, 0.8, 1], [0, 1, 1, 0]);
  return <motion.section ref={sectionRef} style={{
    opacity
  }} className="py-20 md:py-28 bg-black relative overflow-hidden" data-id="element-4053" data-mp="s1bgz7r7l72p">
      <div className="absolute inset-0 bg-gradient-to-b from-amber-950/10 to-black z-0" data-id="element-4054" data-mp="ibi7qdejh41m"></div>
      <div className="container mx-auto px-4 relative z-10" data-id="element-4055" data-mp="n9a17buu0y7x">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-16" data-id="element-4056" data-mp="n7gpvj99xptl">
          <p className="text-amber-400/60 tracking-[0.3em] text-xs uppercase mb-6" data-id="element-4057" data-mp="2vgdhh48or25t">
            Your Investment Includes
          </p>
          <h2 className="font-serif text-5xl md:text-6xl text-white mb-8" data-id="element-4058" data-mp="3981urauo7wod">
            WHAT SPONSORS <span className="text-amber-400" data-id="element-4059" data-mp="3581dzjk3n9e5">RECEIVE</span>
          </h2>
          <div className="w-24 h-px bg-amber-400/30 mx-auto" data-id="element-4060" data-mp="2hiothnjbnewj"></div>
        </motion.div>

        <div className="max-w-4xl mx-auto" data-id="element-4061" data-mp="2cjc9rbnqyny6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-4062" data-mp="2ckf1tmwt2wfo">
            {['Premium brand visibility throughout the event', 'Tax-deductible charitable donation receipt', 'Professional photography from the evening', 'Press kit inclusion and media distribution', 'Digital content package for social channels', 'Networking with community and diaspora leaders', 'Recognition in event program and credits', 'Access to future partnership opportunities'].map((benefit, i) => <motion.div key={i} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: i * 0.05
          }} className="flex items-center gap-4 border border-amber-400/20 p-4 bg-black/40" data-id="element-4063" data-mp="2zm71q8n8b6eg" data-mpi={i}>
                <CheckCircle className="w-5 h-5 text-amber-400 flex-shrink-0" data-id="element-4064" data-mp="2pmya3mfu63v9" />
                <span className="text-white/70 font-light text-sm" data-id="element-4065" data-mp="1s729yfazn0x5">
                  {benefit}
                </span>
              </motion.div>)}
          </div>
        </div>
      </div>
    </motion.section>;
}
function CorporateCTA() {
  const sectionRef = useRef<HTMLElement>(null);
  const {
    scrollYProgress
  } = useScroll({
    target: sectionRef,
    offset: ['start end', 'end start']
  });
  const opacity = useTransform(scrollYProgress, [0, 0.2, 0.8, 1], [0, 1, 1, 0]);
  return <motion.section ref={sectionRef} style={{
    opacity
  }} className="py-20 md:py-28 bg-black relative overflow-hidden" data-id="element-4066" data-mp="1bmv02dr95cu9">
      <div className="container mx-auto px-4" data-id="element-4067" data-mp="16pbgcybsc7ux">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="max-w-3xl mx-auto text-center" data-id="element-4068" data-mp="11w8kgjjjcmbk">
          <Sparkles className="w-10 h-10 text-amber-400 mx-auto mb-6" data-id="element-4069" data-mp="ixnzl988md6d" />
          <h2 className="font-serif text-4xl md:text-5xl text-white mb-6" data-id="element-4070" data-mp="iyfuehu0g6vl">
            Ready to <span className="text-amber-400" data-id="element-4071" data-mp="26uvim84xzmzw">Partner?</span>
          </h2>
          <div className="w-24 h-px bg-amber-400/30 mx-auto mb-8" data-id="element-4072" data-mp="2btozmajftw4t"></div>
          <p className="text-xl text-white/70 font-light mb-10 leading-relaxed" data-id="element-4073" data-mp="1xtnu2hs8a0j0">
            We welcome the opportunity to discuss how a partnership with Life in
            the Sikh Kingdoms can serve your brand, your team, and your
            community.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-4074" data-mp="1o1rludwfgu12">
            <motion.a href="https://wa.me/14169998778?text=I%20am%20interested%20in%20corporate%20sponsorship%20for%20Life%20in%20the%20Sikh%20Kingdoms" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-3 bg-amber-400 hover:bg-amber-500 text-black px-8 py-4 font-medium tracking-wider uppercase text-sm transition-colors duration-300" whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} data-id="element-4075" data-mp="1svcmyetbi44h">
              <MessageCircle className="w-5 h-5" data-id="element-4076" data-mp="lki1jmw9zvwo" />
              Inquire via WhatsApp
            </motion.a>
            <Link to="/" className="inline-flex items-center justify-center gap-2 border-2 border-amber-400/50 hover:border-amber-400 text-white hover:text-amber-400 px-8 py-4 font-light tracking-wider uppercase text-sm transition-all duration-300" data-id="element-4077" data-mp="zkj3z6s6vbe9">
              <ArrowLeft className="w-4 h-4" data-id="element-4078" data-mp="14h9g5j0vhmue" />
              Back to Main Site
            </Link>
          </div>
          <p className="text-white/40 text-sm font-light mt-6" data-id="element-4079" data-mp="1j65o7g2xizv0">
            Our team will respond within 24 hours to discuss partnership
            opportunities.
          </p>
        </motion.div>
      </div>
    </motion.section>;
}